export default __webpack_public_path__ + "static/media/pahang2021A.b46ef9ce.jpg";